<template>
  <div class="white--text grey darken-3" style="line-height:64px">
    <p class="text-center">Design By Sean Lin</p>
  </div>
</template>

<script>
export default {

};
</script>
